export default "__VITE_PUBLIC_ASSET__560784fa__"